import { cloneDeep } from '@apollo/client/utilities';
import { Address } from '../common/address';
import { CompanyEntity, forCreate, forDelete, forUpdate } from '../common/entity';

export const SystemStockLocation = {
  id: '00000000-0000-0000-0000-000000000001',
  name: 'SYSTEM',
};

export class StockLocation extends CompanyEntity {
  name!: string;
  identifier?: string;
  mobile?: boolean;
  image?: string;
  address?: Address;
  administrators: string[] = [];
  refillId?: string;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, cloneDeep(obj));
  }
}

export class CreateStockLocationInput extends forCreate(StockLocation) {}

export class UpdateStockLocationInput extends forUpdate(StockLocation) {}

export class DeleteStockLocationInput extends forDelete(StockLocation) {}
